import { useTheme } from '@/lib/theme';

/**
 * Custom hook that respects user's theme preference
 * Returns resolved color scheme based on preference and system settings
 */
export function useColorScheme() {
  const { colorScheme } = useTheme();
  return colorScheme;
}
